module.exports = __webpack_public_path__ + "img/img3.2f79131f.png";